import {
  useEffect,
  RefObject,
} from "react";
import { updateScrollToNow } from "./utils/calculateScrollToNow";

interface UseInitialScrollToNowProps {
  containerRef: RefObject<HTMLDivElement>;
  enabled: boolean;
  isFetched: boolean;
  date: Date;
  startHour: number;
  endHour: number;
  fixedWidth: number;
  isProgrammaticScrollRef?: { current: boolean }; // Ref para marcar scroll programático
}

/**
 * Hook para fazer scroll inicial e centralizar o "now" na primeira renderização
 * Executa apenas uma vez quando o componente é montado e os dados estão prontos
 */
export function useInitialScrollToNow({
  containerRef,
  enabled,
  isFetched,
  date,
  startHour,
  endHour,
  fixedWidth,
  isProgrammaticScrollRef,
}: UseInitialScrollToNowProps): void {
  useEffect(() => {
    if (!enabled || !isFetched || !containerRef.current) {
      return undefined;
    }

    // Aguarda renderização do DOM
    const timeoutId = setTimeout(() => {
      if (!containerRef.current) {
        return;
      }

      updateScrollToNow(
        containerRef.current,
        date,
        startHour,
        endHour,
        fixedWidth,
        undefined,
        isProgrammaticScrollRef
      );
    }, 100);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []); // Executa apenas uma vez na montagem
}
